export default "__VITE_ASSET__D7Jh3cEh__"